module.exports = __webpack_public_path__ + "img/yrityslainaa-5000-euroa-2.3dc57c3.jpg";